var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.915 43.809"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".warning_svg__cls-1{fill:inherit}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__warning",
    transform: "translate(0 -26.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__Group_17101",
    "data-name": "Group 17101",
    transform: "translate(0 26.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__Group_17100",
    "data-name": "Group 17100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "warning_svg__Path_31368",
    "data-name": "Path 31368",
    className: "warning_svg__cls-1",
    d: "M48.174 62.339L29.186 29.45a5.46 5.46 0 00-9.457 0L.74 62.339a5.46 5.46 0 004.729 8.19h37.977a5.46 5.46 0 004.729-8.19zm-2.484 4.026a2.566 2.566 0 01-2.245 1.3H5.469a2.592 2.592 0 01-2.245-3.888l18.988-32.893a2.592 2.592 0 014.489 0L45.69 63.773a2.566 2.566 0 010 2.592z",
    transform: "translate(0 -26.72)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__Group_17103",
    "data-name": "Group 17103",
    transform: "translate(22.545 58.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__Group_17102",
    "data-name": "Group 17102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "warning_svg__Path_31369",
    "data-name": "Path 31369",
    className: "warning_svg__cls-1",
    d: "M237.9 355.183a1.912 1.912 0 101.912 1.912 1.914 1.914 0 00-1.912-1.912z",
    transform: "translate(-235.984 -355.183)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__Group_17105",
    "data-name": "Group 17105",
    transform: "translate(23.023 40.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_svg__Group_17104",
    "data-name": "Group 17104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "warning_svg__Rectangle_17807",
    "data-name": "Rectangle 17807",
    className: "warning_svg__cls-1",
    d: "M0 0h2.868v14.819H0z"
  }))))));
}

export default SvgWarning;